import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useSocket } from '../hooks/useSocket';

// A slim, ambient pill under the header that surfaces the latest party
// moment (joins, votes, adds, skips) — visible energy without toast spam.
// Always reserves its height so the layout doesn't jump.
const ActivityTicker = () => {
  const { activity } = useSocket();
  const latest = activity[activity.length - 1];
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!latest) return undefined;
    setVisible(true);
    const timer = setTimeout(() => setVisible(false), 6000);
    return () => clearTimeout(timer);
  }, [latest?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="h-9 flex items-center justify-center overflow-hidden" aria-live="polite">
      <AnimatePresence mode="wait">
        {visible && latest && (
          <motion.div
            key={latest.id}
            initial={{ y: 12, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -12, opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="jh-glass rounded-full px-4 py-1.5 text-xs text-gray-200 flex items-center gap-1.5 border border-white/10 max-w-[90vw]"
          >
            <span aria-hidden="true">{latest.icon}</span>
            <span className="truncate min-w-0">{latest.text}</span>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default ActivityTicker;
